export default __webpack_public_path__ + "images/e67158672d64c343bf6b382b933f55a2-golf.webp";